/**
 * Formats a date from yyyy-mm-dd to dd/mm/yyyy
 * @param {string} dateStr - The date string in yyyy-mm-dd format
 * @returns {string} - The formatted date string in dd/mm/yyyy format
 */
export const formatDate = (dateStr: string | undefined): string => {
    if (!dateStr) {
        return 'Invalid date';
    }

    const parts = dateStr.split('-');
    if (parts.length !== 3) {
        return 'Invalid date format';
    }
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
};

export const calculateAge = (dateOfBirth?: string): number | null => {
    if (!dateOfBirth || !/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateOfBirth)) return null;

    const [year, month, day] = dateOfBirth.split('-').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) {
        age--;
    }

    return age;
};

export const calculateRetirementAge = (dateOfBirth?: string): number => {
    const age = calculateAge(dateOfBirth);
    if (!age) return 67;

    const cutoff = new Date(1961, 2, 5);
    const [year, month, day] = dateOfBirth!.split('-').map(Number);
    const birthDate = new Date(year, month - 1, day);

    if (age > 67) return age;

    return birthDate <= cutoff ? 66 : 67;
};

export const getAgeRange = (startAge: number, endAge: number | null) => {
    if (!endAge) return `${startAge}+`;

    return endAge - startAge > 1 ? `${startAge} - ${endAge - 1}` : `${startAge}`;
};
